/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { contactResponseDtoSchema } from "./contactResponseDtoSchema";
import { pendingContactChangesetDtoSchema } from "./pendingContactChangesetDtoSchema";
import { z } from "zod/v4";

export const contactWithPendingChangesetResponseDtoSchema = z.object({
    get "contact"(){
                return contactResponseDtoSchema
              },
get "pendingContactChangeset"(){
                return pendingContactChangesetDtoSchema.nullish()
              }
    })